import { useSelector } from 'react-redux';

import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { BALLOON, FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';

export enum CashDownVariant {
    CASH_RECEIVED = 'cashReceived',
    DEFERMENT = 'deferment',
    CASH_DOWN = 'cashDown'
}

export const useCashDownVariant = (): CashDownVariant => {
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isEquityAllocationOrderEnabled = useSelector(featureToggleSelectors.isEquityAllocationOrderEnabled);
    const isDeferredDownPaymentEnabled = useSelector(dealerSelectors.isDeferredDownPaymentEnabled);

    if (offerType === LEASE && isEquityAllocationOrderEnabled) {
        return CashDownVariant.CASH_RECEIVED;
    }
    if ((offerType === FINANCE || offerType === BALLOON) && isDeferredDownPaymentEnabled) {
        return CashDownVariant.DEFERMENT;
    }
    return CashDownVariant.CASH_DOWN;
};
